{
  "shape": "box",
  "shapeSize": 0.994,
  "tiltX": 8.6,
  "tiltY": 8.1,
  "tiltResponse": 15,
  "zoom": 1.05,
  "waveAmplitude": 1.5,
  "waveSpeed": 10.200000000000001,
  "waveWidth": 3,
  "waveFrequency": 0.7000000000000001,
  "waveFade": 1.8,
  "waveAttack": 0.16,
  "pointerResponse": 6,
  "trailSpacing": 0.12,
  "cursorRadius": 3.1,
  "cursorResponse": 7,
  "cursorDepth": 0.66,
  "clickStrength": 1.6,
  "clickDepth": 1.1,
  "clickDuration": 0.85,
  "baseColor": "#f4f3f1",
  "brandColor": "#ff0058",
  "colorMix": 0.3,
  "opacity": 0.79,
  "ambient": 1.5,
  "light": 2,
  "shadowSoftness": 5,
  "postprocessing": true,
  "aberration": 0.008400000000000001,
  "blurBase": 0.4,
  "blurEdge": 4,
  "vignette": 0.07,
  "edgeStart": 0.25,
  "edgeSoftness": 0.46
}
